import type { DraggableSortEvent } from '@/components/shared/types'

export type DraggableSortEventWithId = DraggableSortEvent<{ id: string }>

export const parseDraggableSortEvent = (event: DraggableSortEventWithId) => {
  const { movedItem, sortedItems } = event
  const movedIndex = sortedItems.findIndex((sortedItem) => sortedItem.id === movedItem.id)
  const previousId = sortedItems[movedIndex - 1]?.id ?? null
  return { id: movedItem.id, previousId }
}

export type DraggableRecord = {
  id: string
  order: number
}

export const reorderDraggableList = <T extends DraggableRecord>(
  list: T[],
  id: string,
  previousId: string | null,
): T[] => {
  const selectedIndex = list.findIndex((item) => item.id === id)
  const previousIndex = list.findIndex((item) => item.id === previousId)
  const selectedItem = list[selectedIndex]

  const sortedList = list.reduce<T[]>((newList, item, index) => {
    if (item === selectedItem) return newList
    if (!index && !previousId) {
      newList.push(selectedItem)
    }
    newList.push(item)
    if (index === previousIndex) {
      newList.push(selectedItem)
    }
    return newList
  }, [])

  return sortedList.map<T>((item, order) => ({ ...item, order }))
}
